import React, { useState, useEffect } from "react";

// react-router components
import { useNavigate } from "react-router-dom";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import AddIcon from "@mui/icons-material/Add";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// Market Place React components
import MDBox from "components/MDBox";

// Market Place React example components
import NotificationItem from "examples/Items/NotificationItem";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
// Custom styles for DashboardNavbar
import { navbarRow } from "examples/Navbars/DashboardNavbar/styles";
// Market Place React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setLogout,
  setOpenConfigurator,
} from "context";
import getText from "Translator";
import { setAction } from "context";

function DashboardNavbar({ absolute, light, searchHandler, title, showserch }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
    lang,
  } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }
    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
    >
      {/* <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem
        icon={<Icon>podcasts</Icon>}
        title="Manage Podcast sessions"
      /> */}
      <NotificationItem
        onClick={() => {
          setLogout(dispatch, !miniSidenav);
          navigate("/", { replace: true });
        }}
        icon={<ExitToAppIcon />}
        title={getText("exit", "fa")}
      />
      <NotificationItem
        onClick={() => {
          setLogout(dispatch, !miniSidenav);
          navigate("/", { replace: true });
        }}
        icon={<InsertEmoticonIcon />}
        title={getText("profile", "fa")}
      />
    </Menu>
  );

  return (
    <AppBar position="fixed" color="primary" mb={5} style={{direction: "ltr"}}>
      <Toolbar>
        <MDBox
          color="inherit"
          mb={{ md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini: true })}
          md={(theme) => navbarRow(theme, { isMini: true })}
        >
           {controller.header && controller.header.includes("nextpage") && (
              <IconButton
                style={{
                  float: "right",
                }}
                color="inherit"
                aria-label="ArrowForwardIosIcon"
                onClick={() => {
                  setAction(dispatch, "nextpage" + new Date());
                }}
              >
                <ArrowForwardIcon />
              </IconButton>
            )}
          {controller.authenticated &&
            controller.header &&
            controller.header.includes("backfirstpage") && (
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                onClick={() => {
                  setAction(dispatch, "backfirstpage");
                }}
              >
                <KeyboardReturnIcon fontSize="medium" />
              </IconButton>
            )}
          {/* {controller.header && controller.header.includes("pageslist") && (
            <IconButton
              style={{
                float: "right",
              }}
              disableRipple
              color="inherit"
              onClick={() => {
                setAction(dispatch, "pageslist" + new Date());
              }}
            >
              <ListIcon />
            </IconButton>
          )} */}
          <div style={{ flex: 1, flexDirection: "row" }}>
            <div
              className="title"
              style={{
                textAlign: "center",
                flex: 1,
                width: "100%",
                overflow: "hidden",
                fontWeight: "bold",
                maxHeight: "30px",
              }}
            >
              {controller.title}
            </div>
            <div className="subtitle">{controller.subtitle}</div>
          </div>

          {/* <MDBox pr={1} pl={2}>
            {showserch && (
              <TextField
                fullWidth
                style={{ color: "#FFF" }}
                onChange={(event) => {
                  searchHandler(event.target.value);
                }}
                placeholder={getText("search", lang)}
              />
            )}
          </MDBox> */}
          <MDBox color={light ? "white" : "inherit"}>
            {/* <IconButton
              size="small"
              disableRipple
              color="inherit"
              onClick={handleOpenMenu}
            >
              <Icon fontSize="medium">account_circle</Icon>
            </IconButton> 
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              onClick={handleOpenMenu}
            >
              <Icon fontSize="medium">account_circle</Icon>
            </IconButton>
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarMobileMenu}
              onClick={handleMiniSidenav}
            >
              <Icon fontSize="medium">
                {miniSidenav ? "menu_open" : "menu"}
              </Icon>
            </IconButton>*/}
            {/*     <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarIconButton}
              onClick={handleConfiguratorOpen}
            >
              <Icon sx={iconsStyle}>settings</Icon>
            </IconButton>
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarIconButton}
              aria-controls="notification-menu"
              aria-haspopup="true"
              variant="contained"
              onClick={handleOpenMenu}
            >
              <Icon>notifications</Icon>
            </IconButton>*/}
            {controller.header && controller.header.includes("selectgroup") && (
              <IconButton
                style={{
                  float: "right",
                }}
                color="inherit"
                aria-label="selectgroup"
                onClick={() => {
                  setAction(dispatch, "selectgroup");
                }}
              >
                <GroupsOutlinedIcon />
              </IconButton>
            )}
            {controller.header && controller.header.includes("addfile") && (
              <>
                <IconButton
                  style={{
                    float: "right",
                  }}
                  color="inherit"
                  aria-label="addfile"
                  onClick={() => {
                    setAction(dispatch, "addfile");
                  }}
                >
                  <PostAddOutlinedIcon />
                </IconButton>
                <IconButton
                  style={{
                    float: "right",
                  }}
                  color="inherit"
                  aria-label="ArrowForwardIosIcon"
                  onClick={() => {
                    setAction(dispatch, "filemenu" + new Date());
                  }}
                >
                  <MenuIcon />
                </IconButton>
              </>
            )}
           
            {controller.header && controller.header.includes("backpage") && (
            <IconButton
              color="inherit"
              aria-label="ArrowBackIosIcon"
              onClick={() => {
                setAction(dispatch, "backpage" + new Date());
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
            {controller.header && controller.header.includes("cooperate") && (
              <IconButton
                style={{
                  float: "right",
                }}
                color="inherit"
                aria-label="cooperate"
                onClick={() => {
                  setAction(dispatch, "cooperate" + new Date());
                }}
              >
                <AddIcon />
              </IconButton>
            )}

            {controller.authenticated && controller.header && controller.header.includes("resultpagemenu") && (
              <IconButton
                style={{
                  float: "right",
                }}
                color="inherit"
                aria-label="ArrowForwardIosIcon"
                onClick={() => {
                  setAction(dispatch, "resultpagemenu" + new Date());
                }}
              >
                <MenuIcon />
              </IconButton>
            )}
            {controller.header &&
              !controller.header.includes("resultpagemenu") &&
              controller.header.includes("allowcopy") && (
                <IconButton
                  style={{
                    float: "right",
                  }}
                  color="inherit"
                  aria-label="allowcopy"
                  onClick={() => {
                    setAction(dispatch, "allowcopy" + new Date());
                  }}
                >
                  <ContentCopyIcon />
                </IconButton>
              )}
            {controller.header && controller.header.includes("commentmenu") && (
              <IconButton
                style={{
                  float: "right",
                }}
                color="inherit"
                aria-label="MessageOutlinedIcon"
                onClick={() => {
                  setAction(dispatch, "commentmenu" + new Date());
                }}
              >
                <MessageOutlinedIcon />
              </IconButton>
            )}
            {controller.header && controller.header.includes("attach") && (
              <IconButton
                style={{
                  float: "right",
                }}
                color="inherit"
                aria-label="AttachFileIcon"
                onClick={() => {
                  setAction(dispatch, "attach" + new Date());
                }}
              >
                <AttachFileOutlinedIcon />
              </IconButton>
            )}
            {renderMenu()}
          </MDBox>
        </MDBox>
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
